import Property from "./Property";

export default class Context {
  constructor(record = { data: {} }) {
    this.properties = record.data.properties
      ? record.data.properties.map((c) => new Property(c))
      : [];
    this.measurements = record.data.measurements
      ? record.data.measurements
      : [];
    this.userRightsAccess = record.data.userRightsAccess
      ? record.data.userRightsAccess
      : [];
    this.units = record.data.units ? record.data.units : [];
    this.isActive =
      typeof record.data.isActive === "undefined" ? true : record.data.isActive;
    this.lastUpdatedOn = record.data.lastUpdatedOn || undefined;
    this.lastUpdatedBy = record.data.lastUpdatedBy || undefined;
    this.deletedOn = record.data.deletedOn || undefined;
    this.deletedBy = record.data.deletedBy || undefined;
  }
}
